<div class="shared-modal position-relative container-fluid py-3">
    <div class="d-flex align-items-center justify-content-between">
        <h4>Share With</h4>
        <div class="crossbtn text-end" (click)="onNoClick()">
            <img class="align-top"  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/close.svg'" alt="Close | Luminous" />
        </div>
    </div>
    <!-- <share-buttons theme="circles-dark" [include]="['copy', 'facebook', 'email', 'telegram', 'twitter', 'whatsapp']"
        [showIcon]="true" [showText]="true" [url]="url" description="Luminous India" twitterAccount="myluminous"
        class="pt-5">
    </share-buttons> -->
    <div class="maincontent">
    <div class="share-button copy" (click)="copyLink()">
      <a class="Copy-button">
         <img  loading="lazy" [src]="imgSrc" alt="svg">
      </a>
      <span>{{ buttonText }}</span>
    </div>
    <div class="share-button email">
      <a (click)="shareViaEmail()">
      <div class="Copy-button" >
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/shareIcons/Email.svg'" alt="Email">
          </div>
      <span>Email</span>
    </a>
    </div>
    <div class="share-button telegram">
      <a (click)="shareOnTelegram()">
      <div class="Copy-button ">
     <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/shareIcons/telegram.svg'" alt="Telegram">
      </div>
      <span>Telegram</span>
    </a>
    </div>
    <div class="share-button twitter">
      <a (click)="shareOnTwitter()">
      <div class="Copy-button ">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/shareIcons/twitter.svg'" alt="Twitter">
        </div>
      <span>Twitter</span>
    </a>
    </div>
    <div class="share-button whatsapp">
      <a (click)="shareOnWhatsApp()">
      <div class="Copy-button">
        <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/shareIcons/whatsapp.svg'" alt="Whatsapp">
      </div>
      <span>Whatsapp</span>
    </a>
    </div>
  </div>
</div>
